<div class="family-card">
    <!-- =====================================================
         ENCABEZADO
         ===================================================== -->
    <div class="family-header">
        <div>
            <span class="family-eyebrow">
                FAMILIARES
            </span>
            <h2>
                Familiares y amigos
            </h2>
            <p>
                Guarda sus cumpleaños y te ayudamos a que nunca falte el pastel.
            </p>
        </div>
        <button class="family-add-button" mat-raised-button type="button" (click)="addFamily()">
            Agregar familiar
        </button>
    </div>
    <!-- =====================================================
         SIN FAMILIARES
         ===================================================== -->

    <div class="family-empty" *ngIf="dataFamiliars.length === 0">
        <h3>
            Sin familiares o amigos
        </h3>
        <p>
            Actualmente no tienes familiares o amigos guardados.
            Puedes incluir uno nuevo presionando el botón
            <strong>Agregar familiar</strong>.
        </p>
        <button class="family-empty-button" mat-raised-button type="button" (click)="addFamily()">
            Agregar familiar
        </button>
    </div>
    <!-- =====================================================
         LISTA DE FAMILIARES
         ===================================================== -->
    <div class="family-list" *ngIf="dataFamiliars.length > 0">
        <div class="family-item" *ngFor="let familiar of dataFamiliars">
            <!-- Información -->
            <div class="family-item-info">
                <div class="family-item-name">

                    {{
                    familiar.first_name ||
                    familiar.name ||
                    'Sin nombre'
                    }}

                    {{
                    familiar.last_name
                    ? ' ' + familiar.last_name
                    : ''
                    }}

                    {{
                    familiar.last_name2
                    ? ' ' + familiar.last_name2
                    : ''
                    }}
                </div>
                <div class="family-item-details">
                    <span>
                        {{
                        familiar.parentezco?.name ||
                        'Sin parentesco'
                        }}
                    </span>
                    <span class="family-separator">
                        •
                    </span>
                    <span>
                        {{ formatBirthdate(familiar.birthdate) }}
                    </span>
                </div>
            </div>
            <!-- Acciones -->
            <div class="family-item-actions">
                <button class="family-edit-button" type="button" aria-label="Editar familiar"
                    (click)="editFamily(familiar)">
                    Editar
                </button>
                <button class="family-delete-button" type="button" aria-label="Eliminar familiar"
                    (click)="deleteFamily(familiar.id)">
                    <mat-icon>
                        delete_outline
                    </mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>